import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { useScrollTop } from '@alycecom/hooks';

import PageWithDataWrapper from '../../../../components/PageWithDataWrapper';
import StyledHeader from '../StyledHeader/StyledHeader';
import useGoBack from '../../../../hooks/useGoBack';
import { declineGiftRequest, resetErrors } from '../../store/decline/decline.actions';
import { getIsDeclined } from '../../store/decline/decline.selectors';
import { getGiftHashId, getGiftProduct } from '../../store/data/data.selectors';
import Footer from '../../../../components/Shared/Footer';
import usePageLoadEvent from '../../../../hooks/usePageLoadEvent';
import { getIsGiftDataLoaded } from '../../store/recipient.selectors';

import GiftDeclineForm from './GiftDeclineForm/GiftDeclineForm';

export interface IDeclinePageProps {
  parentUrl: string;
}

const DeclinePage = ({ parentUrl }: IDeclinePageProps): JSX.Element => {
  const dispatch = useDispatch();

  const isGiftDataLoaded = useSelector(getIsGiftDataLoaded);
  const hashId = useSelector(getGiftHashId);
  const isDeclined = useSelector(getIsDeclined);
  const sentProduct = useSelector(getGiftProduct);

  const handleGoBack = useGoBack(parentUrl);

  const handleDeclineGift = useCallback(
    reason => {
      dispatch(declineGiftRequest({ hashId, reason, product: sentProduct }));
    },
    [hashId, dispatch, sentProduct],
  );

  const handleResetErrors = useCallback(() => dispatch(resetErrors()), [dispatch]);

  useScrollTop();
  usePageLoadEvent('Decline Page - Opened');

  useEffect(() => {
    handleResetErrors();
  }, [handleResetErrors]);

  // Redirect for default decline
  useEffect(() => {
    if (isDeclined) {
      window.location.href = `/error/decline?hashid=${hashId}`;
    }
  }, [isDeclined, hashId]);

  return (
    <PageWithDataWrapper isLoaded={isGiftDataLoaded}>
      <Box bgcolor="common.white">
        <StyledHeader onBackClick={handleGoBack} />
        <Box
          width={1}
          height={['calc(100vh - 56px)', 'calc(100vh - 80px)']}
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
        >
          <Box width={1}>
            <GiftDeclineForm onSubmit={handleDeclineGift} />
          </Box>
          <Footer mobileHidden />
        </Box>
      </Box>
    </PageWithDataWrapper>
  );
};

export default DeclinePage;
